import React from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import styles from './Spinner.module.scss';

export interface SpinnerProps {
    fullPage?: boolean;
    isLoading: boolean;
}

const Spinner: React.FunctionComponent<SpinnerProps> = ({ fullPage = false, isLoading }) => {
    if (fullPage) return (
        <Dimmer active={isLoading} role="status" aria-live="polite">
            <Loader active={isLoading} />
            {isLoading && <span className="visually-hidden">Loading</span>}
        </Dimmer>
    )
    return (
        <div role="status" aria-live="polite">
            <Loader className={styles.spinner} active={isLoading} inline />
            {isLoading && <span className="visually-hidden">Loading</span>}
        </div>
    )
}

export { Spinner };